export default "__VITE_ASSET__D_V2DCVO__"